module.exports = __webpack_public_path__ + "static/media/menu.55d067ab.png";